export const APP_NAME = 'wiwitan';
export const PERSIST_STORE_NAME = 'admin';
export const ROLE_SUPER = 'super-admin';
export const ROLE_ADMIN = 'gc-admin';
export const REDIRECT_URL_KEY = 'redirectUrl';
